// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'Hooks';
import { GetFolderDetailsRoute } from 'Utils/routes';
import { SetMapFolderAction, SetShowMapviewAction } from './projectListActions';

// The Projects / Map switch, shared by the dashboard's search row and the map rail so both enter
// and leave the map the same way. The view lives in the store rather than component state, so
// the choice survives navigating within the tab during the session.
export const useMapViewToggle = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const mapFolderId = useAppSelector((state) => state.projectList.mapFolderId);

  // Opening the map from the dashboard means every project - a folder scope left over from a
  // previous visit would silently hide most of them.
  const showMap = () => {
    dispatch(SetMapFolderAction(null));
    dispatch(SetShowMapviewAction(true));
  };

  // Leaving the map inside a folder lands on that folder, not back on the whole dashboard - the
  // folder is where the user was.
  const showProjects = () => {
    dispatch(SetShowMapviewAction(false));
    if (mapFolderId) {
      dispatch(SetMapFolderAction(null));
      navigate(GetFolderDetailsRoute(mapFolderId));
    }
  };

  return { showMap, showProjects };
};

export default useMapViewToggle;
